var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.545,
    height: 18.273,
    viewBox: "0 0 25.545 18.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54357",
    "data-name": "Path 54357",
    d: "M43.476,59.863a2.879,2.879,0,1,1,2.905-2.879A2.9,2.9,0,0,1,43.476,59.863Zm0-4.949a2.071,2.071,0,1,0,2.1,2.071A2.087,2.087,0,0,0,43.476,54.913Zm0,0",
    transform: "translate(-38.522 -51.373)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54358",
    "data-name": "Path 54358",
    d: "M6.123,189.144H1.056A1.054,1.054,0,0,1,0,188.094v-1.321a4.964,4.964,0,0,1,7.911-3.936.4.4,0,0,1-.48.65,4.156,4.156,0,0,0-6.623,3.286v1.321a.245.245,0,0,0,.248.241H6.123a.4.4,0,1,1,0,.808Zm0,0",
    transform: "translate(0 -172.684)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54359",
    "data-name": "Path 54359",
    d: "M340.054,183.092h-5.067a.4.4,0,1,1,0-.808h5.067a.245.245,0,0,0,.248-.241v-1.321a4.127,4.127,0,0,0-4.146-4.1,4.184,4.184,0,0,0-2.625.926.4.4,0,1,1-.508-.628,5,5,0,0,1,3.133-1.106,4.936,4.936,0,0,1,4.954,4.906v1.321a1.054,1.054,0,0,1-1.056,1.049Zm0,0",
    transform: "translate(-316.065 -166.939)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54360",
    "data-name": "Path 54360",
    d: "M343.257,55.91a2.879,2.879,0,1,1,2.906-2.879A2.9,2.9,0,0,1,343.257,55.91Zm0-4.949a2.071,2.071,0,1,0,2.1,2.071A2.087,2.087,0,0,0,343.257,50.96Zm0,0",
    transform: "translate(-323.166 -47.62)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54361",
    "data-name": "Path 54361",
    d: "M125.548,165.737H114.583a1.318,1.318,0,0,1-1.321-1.311v-1.858a6.8,6.8,0,0,1,13.607,0v1.858a1.318,1.318,0,0,1-1.321,1.311Zm-5.483-9.1a5.969,5.969,0,0,0-6,5.928v1.858a.509.509,0,0,0,.513.5h10.965a.509.509,0,0,0,.513-.5v-1.858a5.968,5.968,0,0,0-6-5.928Zm0,0",
    transform: "translate(-107.543 -147.963)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54362",
    "data-name": "Path 54362",
    d: "M175.015,7.4a3.72,3.72,0,0,1-3.733-3.7,3.734,3.734,0,0,1,7.467,0,3.72,3.72,0,0,1-3.734,3.7Zm0-6.589a2.911,2.911,0,0,0-2.925,2.89,2.926,2.926,0,0,0,5.851,0,2.912,2.912,0,0,0-2.926-2.89Zm0,0",
    transform: "translate(-162.633 0)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownGroups);
export default __webpack_public_path__ + "static/media/profiledropdown-groups.3610e25ef23f9aed1b6e556332fc1086.svg";
export { ForwardRef as ReactComponent };